import React from 'react';
import { FormTypes } from './SignersForm';
import { ISignerResponse } from '../../../../../../types/signingAppointment/ISignerResponse';
import { v4 as uuid } from 'uuid';
import { css } from '@/styled-system/css';
import { IconPlusOutline } from '@zillow/constellation-icons';
import { Button } from '@zillow/constellation-10';

const invalid = 'INVALID';

const generateNewSigner = (): Partial<ISignerResponse> => ({
  personId: uuid() + invalid,
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
});

export const AddSignerButtons: React.FC<{ push: (obj: any) => void; onAddSignerClick: (type: FormTypes) => void }> = ({
  push,
  onAddSignerClick,
}) => {
  return (
    <section className={css({ marginTop: '16', display: 'flex', flexDirection: 'row', gap: '16' })}>
      <Button
        tone={'brand'}
        emphasis={'filled'}
        size="sm"
        icon={<IconPlusOutline />}
        iconPosition="start"
        onClick={() => {
          push(generateNewSigner());
          onAddSignerClick(FormTypes.Current);
        }}
      >
        <p>Select Existing</p>
      </Button>

      <Button
        tone={'brand'}
        emphasis={'outlined'}
        size="sm"
        icon={<IconPlusOutline />}
        iconPosition="start"
        onClick={() => {
          push(generateNewSigner());
          onAddSignerClick(FormTypes.New);
        }}
      >
        <p>Add New</p>
      </Button>
    </section>
  );
};
